<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col xs="12" sm="12" md="12" lg="6" xl="6">
        <div class="title mb-1 img-title" align="center">Source Image</div>
        <v-img v-bind:src="sourceImageHref" class="img" align="center"></v-img>
        <v-container>
          <v-row align="center" justify="center" >
            <a v-bind:href="sourceImageHref" download="source.jpeg" >
              <v-btn color="grey lighten-1" fab>
                <v-icon>fas fa-download</v-icon>
              </v-btn>
            </a>
          </v-row>
        </v-container>
      </v-col>
      <v-col xs="12" sm="12" md="12" lg="6" xl="6">
        <div class="title mb-1 img-title" align="center">Target Image</div>
        <v-img v-bind:src="targetImageHref" align="center" class="img"></v-img>
        <v-container>
          <v-row align="center" justify="center" >
            <a v-bind:href="targetImageHref" download="target.jpeg" >
              <v-btn color="grey lighten-1" fab>
                <v-icon>fas fa-download</v-icon>
              </v-btn>
            </a>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ImageViewer",
  props: {
    sourceImageHref: {type: String},
    targetImageHref: {type: String}
  },
}
</script>

<style scoped>
.img {
  margin-left: auto;
  margin-right: auto;
}
.img-title {
  color: lightgray;
}
</style>